import type { BreadcrumbItem } from "Helpers/generalBreadcrumbs";
import { buildSupplierDetailsHref } from "Helpers/suppliersBreadcrumbs";
import { pickProfileEntityTitle } from "Helpers/pickProfileEntityTitle";
import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { VendorProfileService } from "subModule/src/core/services";

export function useFrozenSupplierEntityTitle(supplierId?: string): string {
  const params = useParams();
  const id = supplierId ?? params.id;
  const [entityTitle, setEntityTitle] = useState("");

  useEffect(() => {
    if (!id) return;
    let active = true;
    VendorProfileService.getVendorById(+id)
      .then((res) => {
        if (!active) return;
        const name = pickProfileEntityTitle(res);
        if (name) setEntityTitle(name);
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, [id]);

  return entityTitle;
}

/** Nested supplier tabs — Vendors > Suppliers List > Name > Tab */
export function useFrozenSupplierTabBreadcrumbs(
  actionLabelKey: string,
): BreadcrumbItem[] {
  const { id } = useParams();
  const entityTitle = useFrozenSupplierEntityTitle();

  return useMemo(
    () => [
      { labelKey: "vendors" },
      { labelKey: "suppliersList", href: "/suppliers" },
      {
        labelKey: "title",
        ...(entityTitle ? { label: entityTitle } : {}),
        href: buildSupplierDetailsHref({ id }),
      },
      { labelKey: actionLabelKey },
    ],
    [id, entityTitle, actionLabelKey],
  );
}
